import { useLocation } from 'react-router';

/**
 * URL canónica de una ruta: sin query ni barra final. Las hojas y modales viven en la query
 * (`?registro=1&next=...`, `?calificar=1`, `?estacion=`), así que para Google son la misma página que
 * la ruta sin ellos; sin canónica las marcaba como duplicadas sin versión preferida.
 */
export function canonicalUrl(origin: string, pathname: string): string {
  const path = pathname.replace(/\/+$/, '');
  return `${origin}${path || '/'}`;
}

/** `<link rel="canonical">` de la ruta actual (React lo sube al `<head>`). */
export function CanonicalLink() {
  const { pathname } = useLocation();
  return <link rel="canonical" href={canonicalUrl(window.location.origin, pathname)} />;
}

/**
 * Para las pantallas de "no encontrado": la SPA responde 200 en cualquier ruta, así que sin esto
 * Google indexa el aviso como una página real (soft 404) y todas las estaciones inexistentes quedan
 * como duplicadas entre sí. Solo en 404: un error pasajero no debe sacar una página buena del índice.
 */
export function NoIndex() {
  return <meta name="robots" content="noindex" />;
}
